import { Helpers } from '../../helpers';
import { ICostCodeCostType } from '../../interfaces/icost-code-cost-type';
import { CostCode } from '../cost-code';
import { CostCodeCostTypeProjectCombination } from '../cost-code-cost-type-project-combination';
import { CostType } from '../cost-type';
import { Item } from '../item';
import { ProjectCashCurve } from '../project-cash-curve';
import { ProjectCostCodeCostTypeItem } from '../project-cost-code-cost-type-item';
import { ProjectCostCodeCostTypeItemsRevision } from '../project-cost-code-cost-type-items-revision';
import { ProjectEstimateAtCompletion } from '../project-estimate-at-completion';
import { ProjectResourceItem } from '../project-resource-item';
import { ProjectResourceItemsRevision } from '../project-resource-items-revision';

export class CostCodeCostTypeBase {
  CostCodeCostTypeId: number;
  CostCodeId: number;
  CostTypeId: number;
  IsActive: boolean;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  CostCodeCostTypeProjectCombinations_CostCodeCostType?: Array<CostCodeCostTypeProjectCombination> | null;
  Items_CostCodeCostType?: Array<Item> | null;
  ProjectCashCurves_CostCodeCostType?: Array<ProjectCashCurve> | null;
  ProjectCostCodeCostTypeItems_CostCodeCostType?: Array<ProjectCostCodeCostTypeItem> | null;
  ProjectCostCodeCostTypeItemsRevisions_CostCodeCostType?: Array<ProjectCostCodeCostTypeItemsRevision> | null;
  ProjectEstimateAtCompletions_CostCodeCostType?: Array<ProjectEstimateAtCompletion> | null;
  ProjectResourceItems_CostCodeCostType?: Array<ProjectResourceItem> | null;
  ProjectResourceItemsRevisions_CostCodeCostType?: Array<ProjectResourceItemsRevision> | null;
  CostCode?: CostCode;
  CostType?: CostType;

  constructor(item?: ICostCodeCostType) {
    if (item) {

      this.CostCodeCostTypeId = item.CostCodeCostTypeId;
      this.CostCodeId = item.CostCodeId;
      this.CostTypeId = item.CostTypeId;
      this.IsActive = item.IsActive;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.CostCodeCostTypeProjectCombinations_CostCodeCostType = Helpers.createClassArray(CostCodeCostTypeProjectCombination, item.CostCodeCostTypeProjectCombinations_CostCodeCostType);
      this.Items_CostCodeCostType = Helpers.createClassArray(Item, item.Items_CostCodeCostType);
      this.ProjectCashCurves_CostCodeCostType = Helpers.createClassArray(ProjectCashCurve, item.ProjectCashCurves_CostCodeCostType);
      this.ProjectCostCodeCostTypeItems_CostCodeCostType = Helpers.createClassArray(ProjectCostCodeCostTypeItem, item.ProjectCostCodeCostTypeItems_CostCodeCostType);
      this.ProjectCostCodeCostTypeItemsRevisions_CostCodeCostType = Helpers.createClassArray(ProjectCostCodeCostTypeItemsRevision, item.ProjectCostCodeCostTypeItemsRevisions_CostCodeCostType);
      this.ProjectEstimateAtCompletions_CostCodeCostType = Helpers.createClassArray(ProjectEstimateAtCompletion, item.ProjectEstimateAtCompletions_CostCodeCostType);
      this.ProjectResourceItems_CostCodeCostType = Helpers.createClassArray(ProjectResourceItem, item.ProjectResourceItems_CostCodeCostType);
      this.ProjectResourceItemsRevisions_CostCodeCostType = Helpers.createClassArray(ProjectResourceItemsRevision, item.ProjectResourceItemsRevisions_CostCodeCostType);
      this.CostCode = new CostCode(item.CostCode);
      this.CostType = new CostType(item.CostType);
    }
  }
}